$(document).ready(function(){

	//main slider
		$('.js-slider').slick({
			dots: true,
			speed: 500,
			fade: true,
			//autoplay: true,
			autoplaySpeed: 6000,
		});
	// js-up
		$(".js-up").on("click", function () {
				var body = $("html, body");
				body.stop().animate({scrollTop: 0}, 1500, 'swing');
		});

		//language switcher
		$('.js-language').on('click',function(){
			$(this).addClass('language--active');
		});

		//scrolled menu
		if ($(window).width()<1240){
				$('.js-top').addClass('top--scrolled');
		} else {
				$('.js-top').removeClass('top--scrolled');
		}

		//aos animations
		AOS.init();

		// parallax effect
		if($('.rellax').length) {
			var rellax = new Rellax('.rellax');
		}
		

}); //end documentready

$(window).on("scroll", function () {
	
	//js-up
	var scroll = $(window).scrollTop();
	if (scroll > 600) {
			$(".js-up").addClass("visible");
	} else {
			$(".js-up").removeClass("visible");
	}

	//scrolled menu
	if ($(window).scrollTop() > 0){
		$('.js-top').addClass('top--scrolled');
 	} else {
		if ($(window).width()>1240){
				$('.js-top').removeClass('top--scrolled');
		}
 }

}); //end onscroll